import { computed, reactive, ref, watch } from 'vue';
import qs from 'qs';

function GetObjectWithoutEmptyValues(object) {
  return Object.fromEntries(
    Object.entries(object)
      .sort(([key]) => key)
      .filter(([key, value]) => value != null && value != '')
  );
}

const internalParams = reactive({});
const lastSetURL = ref(window.location.href);

const getParamsFromUrl = url => {
  const urlObject = new URL(url);
  const search = urlObject.search.substring(1); // <- substring to remove questionmark
  const params = GetObjectWithoutEmptyValues(qs.parse(search) || {});
  return params;
};

const updateInternalParamsFromUrl = () => {
  const url = window.location.href;
  lastSetURL.value = url;
  const params = getParamsFromUrl(url);
  if (Object.keys(params).length <= 0) return;

  Object.assign(internalParams, params);
};

const searchParams = computed(() => {
  const searchParams = qs.stringify(internalParams, {
    arrayFormat: 'indices',
    encode: false,
  });
  return searchParams;
});

const currentURLWithSearchParams = computed(() => {
  return [window.location.href.split('?')[0], searchParams.value]
    .filter(Boolean)
    .join('?');
});

watch(currentURLWithSearchParams, url => {
  if (lastSetURL.value === url) return;
  lastSetURL.value = url;

  history.pushState(null, '', url);
});

updateInternalParamsFromUrl();
window.addEventListener('popstate', () => {
  updateInternalParamsFromUrl();
});

export default function useUrlParams() {
  return { params: internalParams };
}
